import Vue from 'vue';
import Component from 'vue-class-component'
import App from './App.vue';
import router from './router';
import './registerServiceWorker';
import {GlobalMixin} from '@/GlobalMixin';


Vue.config.productionTip = false;


Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate'
]);

Vue.mixin(GlobalMixin);

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app');
